import etZoneDataConfig from '@/api/config/etZoneDataConfig'
import { queryKeys } from '@/constant/common'
import { CreateEtZone } from '@/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateEtZone): Promise<void> {
  await etZoneDataConfig.create(payload)
}

function useAddEtZone() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateEtZone) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.etZone])
      toast.success(t('AddMicroClimateSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('AddMicroClimateError'))
    },
  })
}

export default useAddEtZone
